import { render, staticRenderFns } from "./MCQQuestionInput.vue?vue&type=template&id=539b6d1c&scoped=true&"
import script from "./MCQQuestionInput.vue?vue&type=script&lang=js&"
export * from "./MCQQuestionInput.vue?vue&type=script&lang=js&"
import style0 from "./MCQQuestionInput.vue?vue&type=style&index=0&id=539b6d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539b6d1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
